<template>
  <v-snackbar
    v-model="snack.snackbar"
    app
    :color="snack.color"
    outlined
    right
    :timeout="snack.timeout"
    top
    text
  >
    <template v-if="typeof snack.text == 'object'">
      <div v-for="(text, key) in snack.text" :key="key" v-text="text" />
    </template>
    <template v-else>{{ snack.text }}</template>
    <template #action="{ attrs }">
      <v-btn
        :color="snack.color"
        icon
        v-bind="attrs"
        @click="snack.snackbar = !snack.snackbar"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["snack"])
};
</script>
